{
  "settings": "Ayarlar",
  "yourDigitalAssistant": "Dijital Assistanınız",
  "getStarted": "Başlayın",
  "login": "Giriş",
  "loggingIn": "Giriş yapılıyor ...",
  "darkMode": "Karanlık mod",
  "clearHistory": "Geçmişi temizle",
  "historyCleared": "Geçmiş temizlendi",
  "changeLanguage": "Dil",
  "termsAndConditions": "Şartlar ve Koşullar",
  "messagePlaceholder": "Mesajınızı buraya yazın ...",
  "messagePlaceholderDisabled": "Yazma devre dışı ...",
  "feedbackTitle": "Deneyiminizi değerlendirin",
  "feedbackPlaceholder": "Bize anlatın (isteğe bağlı)",
  "feedbackSend": "Gönder",
  "feedbackClose": "Kapat",
  "sessionExpired": "İşlem yapılmadığı için oturumunuzun süresi doldu.",
  "startNewSession": "Yeni bir oturum başlat",
  "apiError": "Hata! Bir şeyler ters gitti. Bunu mümkün olan en kısa sürede düzeltmeye çalışıyoruz.",
  "apiErrorOffline": "İnternete bağlı değilsiniz.",
  "tryAgain": "Tekrar dene",
  "startOver": "Baştan başla",
  "chatEnded": "Sohbet sona erdi.",
  "chatEndedThankYou": "Bizimle sohbet ettiğiniz için teşekkür ederiz!",
  "closeChat": "Kapat",
  "startNewChat": "Tekrar sohbet et",
  "humanTakeoverStarted": "Artık müşteri hizmetlerine aktarılıyor ...",
  "humanTakeoverQueued": "Bir temsilciye bağlanmayı bekliyor",
  "humanTakeoverAnAgent": "Bir ajan",
  "humanTakeoverAgentEntered": "sohbete girdi",
  "humanTakeoverAgentLogout": "görüşmeden ayrıldı",
  "humanTakeoverTransfer": "Yeni bir acenteye aktarılıyorsunuz",
  "humanTakeoverEnded": "Şimdi dijital yardımcınızla sohbet ediyorsunuz",
  "version": "Version",
  "formIntroText": "Bizimle sohbet etmeye başlamak için lütfen aşağıdaki formu doldurun.",
  "formFirstName": "Ad",
  "formLastName": "Soyadı",
  "formName": "Ad",
  "formEmail": "E-posta",
  "formWrongEmail": "Lütfen geçerli bir e-posta adresi girin.",
  "formPhone": "Telefon",
  "formShipmentId": "Gönderi Kimliği",
  "formQuestion": "Sorunuz",
  "formAccountNumber": "Hesap numarası (Ticari Müşteriler için)",
  "formAddress": "Adres",
  "formPostcode": "Posta kodu",
  "formCity": "Kent",
  "formCountry": "ülke",
  "formSubmitButton": "Sohbeti başlat",
  "formEmptyFieldError": "Boş olmasına izin verilmiyor.",
  "formPhoneNumberValidationError": "Geçerli bir telefon numarası değil.",
  "formInputIsBiggerThan50": "En fazla 50 karakter olmalı.",
  "formInputIsBiggerThan100": "En fazla 100 karakter olmalı.",
  "formInputIsBiggerThan2000": "En fazla 2000 karakter olmalı.",
  "widgetEventOnline": "DA mesajı: Kullanıcı tekrar çevrimiçi.",
  "widgetEventHidden": "DA mesajı: Widget gizlendi.",
  "widgetEventVisible": "DA mesajı: Widget görünür.",
  "widgetEventVisibleMinfied": "DA mesajı: Widget görünür, ancak simge durumuna küçültülmüş.",
  "widgetEventMinfied": "DA mesajı: Widget küçültülmüş.",
  "widgetEventMaximized": "DA mesajı: Widget maksimize edildi.",
  "widgetEventSessionExpired": "DA mesajı: Widget oturumunun süresi doldu.",
  "widgetEventHangupHuman": "DA mesajı: Kullanıcı, İnsan devralma oturumunu sonlandırıyor.",
  "widgetEventUserTyping": "DA mesajı: kullanıcı yazıyor.",
  "fileTooLarge": "Çok Büyük Dosyaları Eklemeye Çalışıyorsunuz.",
  "tooManyDiles": "Çok Fazla Dosya Eklemeye Çalışıyorsunuz.",
  "fileInvalidType": "Geçersiz Dosya Türleri Eklemeye Çalışıyorsunuz.",
  "attachmentsDropHere": "Yüklemek için buraya bırakın veya",
  "attachmentsBrowse": "Dosyalara Göz At",
  "attachmentsExtenstionQuantity": "pdf veya resimler (10 dosyaya kadar)",
  "attachmentsSize": "30 MB'a kadar",
  "attachmentsFailedUploading": "Yükleme Başarısız",
  "attachmentsUploading": "Yükleniyor ...",
  "minimizeExpandText": "Şimdi bizimle canlı sohbet edin!",
  "popupWidgetNotificationMessage": "Yeni bir mesaj aldınız!",
  "tabWidgetNotificationMessage": "Yeni Mesaj!",
  "datepickerSendButton": "Göndermek"
}
